/**
 * Placeholder page for organization details
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const styles = () => ({
  label: {
    verticalAlign: 'top',
    paddingRight: '3px',
  },
});

const propTypes = {
  accessToken: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledOrganizationPage({ accessToken, classes }) {
  return (
    <div>
      <h1>Organization</h1>
      <div>
        <label htmlFor="accessToken" className={classes.label}>
          <textarea
            id="accessToken"
            name="accessToken"
            value={accessToken}
            readOnly
            rows="20"
            cols="40"
          />
          Access Token
        </label>
      </div>
    </div>
  );
}

UnstyledOrganizationPage.propTypes = propTypes;

export default withStyles(styles)(UnstyledOrganizationPage);
